// Display-layer Title Case for managed-list values (brands, names, makes, models…).
// DISPLAY ONLY — stored values are never changed. So "BENDIX", "bendix" and "Bendix"
// all render as "Bendix". A small allowlist keeps well-known acronyms/model codes upper
// (GMC, RAM, BMW, V8, 4X4) instead of turning them into "Gmc"/"Ram".

const KEEP_UPPER = new Set([
  "GMC", "RAM", "BMW", "GM", "HD", "USA", "VIN", "LLC", "AC", "DC",
  "ABS", "PTO", "DEF", "DPF", "EGR", "TRW", "ZF", "DAF", "MAN", "GT", "SS",
  "XLT", "XL", "LT", "LS", "TDI", "CDI", "AWD", "FWD", "RWD", "4X4", "4WD",
  "V6", "V8", "V10", "V12", "L", "R", "CNG", "LPG", "PSI", "OEM",
]);

export function titleCase(str) {
  if (str == null || str === "") return str;
  return String(str).replace(/[A-Za-z0-9]+(?:['.][A-Za-z0-9]+)*/g, (word) => {
    const upper = word.toUpperCase();
    if (KEEP_UPPER.has(upper)) return upper;      // known acronym → keep upper
    if (/\d/.test(word)) return upper;            // model/spec codes: F150, 6.7L, M2
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
}

// "year, make & model" — the exact fields a button confirms, in words. An acronym (GVWR) stays upper.
export function fieldList(labels) {
  const w = (labels || []).map((l) => (l === l.toUpperCase() ? l : l.toLowerCase()));
  return w.length < 2 ? w.join("") : `${w.slice(0, -1).join(", ")} & ${w[w.length - 1]}`;
}
